import { z } from 'zod';
export const inviteUserSchema = z.object({
    email: z.string().email().max(254).transform((s) => s.toLowerCase().trim()),
    first_name: z.string().min(1).max(100),
    last_name: z.string().min(1).max(100),
    role: z.enum(['admin', 'staff']),
    business_ids: z.array(z.string().uuid()).optional(),
});
export const acceptInviteSchema = z.object({
    token: z.string().min(32).max(128),
    password: z.string().min(12).max(128),
    first_name: z.string().min(1).max(100),
    last_name: z.string().min(1).max(100),
    display_name: z.string().min(1).max(255).optional(),
});
export const updateUserRoleSchema = z.object({
    role: z.enum(['admin', 'staff']),
});
export const updateBusinessAssignmentsSchema = z.object({
    business_ids: z.array(z.string().uuid()),
});
export const updateProfileSchema = z.object({
    first_name: z.string().min(1).max(100).optional(),
    last_name: z.string().min(1).max(100).optional(),
    display_name: z.string().min(1).max(255).optional(),
});
export const changePasswordSchema = z.object({
    current_password: z.string().min(1),
    new_password: z.string().min(12).max(128),
});
//# sourceMappingURL=users.js.map